import { InjectionToken } from '@angular/core';

export type AdobeDataStore = object[] | undefined;

export const ADOBE_DATA_STORE = new InjectionToken<AdobeDataStore>(
  'AdobeAnalyticsDataStore',
);

// eslint-disable-next-line no-var
export declare var adobeDataLayer: object[];

export function adobeDataStoreFactory(): AdobeDataStore {
  if (typeof adobeDataLayer !== 'undefined') {
    return adobeDataLayer;
  }

  // eslint-disable-next-line no-console
  console.warn(
    'DTM global digitalData object not found, DTM will not be able to see event tracking data',
  );
}
